import { ChangeDetectorRef, Component, ElementRef, HostListener, ViewChild } from '@angular/core';
import { FormGroup, FormBuilder, FormArray, Validators } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { environment } from '../../../../environments/environment';
import { SharedService } from '../../../services/shared.service';
import { consumerPollProducersForChange } from '@angular/core/primitives/signals';

@Component({
  selector: 'app-employee-manager',
  standalone: false,
  templateUrl: './employee-manager.component.html',
  styleUrl: './employee-manager.component.css'
})
export class EmployeeManagerComponent {
  employeeInfo: any = `T3|0941549523 |045200005173 | 946684800000 | 66 Hồ Sĩ Dương|68012491e9cab0670b20274e|3
T4|0941549524 |045200005174 |  200-100 | 66 Hồ Sĩ Dương|68012491e9cab0670b20274e|4`
  selectedRoles: any = [];
  shareObject: any = {
    selectedRows: new Set(),
    lastSelectedIndex: null,
    component: '/users',
    addURL: '/user/employee/create',
    deletedURL: '/user/employee/deleted',
  };
  formHandle!: FormGroup;
  filterForm!: FormGroup
  constructor(
    public sharedService: SharedService,
    private translate: TranslateService,
    private router: Router,
    private fb: FormBuilder,
    private activatedRoute: ActivatedRoute,
    private cdRef: ChangeDetectorRef,
  ) {
    this.shareObject.options = { filter: {}, page: 1, limit: this.sharedService.env.pageSize[0] };
    this.activatedRoute.params.subscribe((params) => {
      if (params['id']) {
        this.shareObject.id = params['id'];
      }
    })
  }
  ngOnInit(): void {
    console.log(this.shareObject.componentUrl)
    this.shareObject.data = this.activatedRoute.snapshot.data;
    this.formHandle = this.fb.group({
      email: ['', [Validators.required, Validators.email]],
      password: [''],
      name: ['', Validators.required],
      identify: ['', Validators.required],
      address: [''],
      dob: [''],
      workStart: [''],
      store: [''],
      // salaryCoefficient: [2],
      phone: ['', Validators.required],
      employeeGroup: ['', Validators.required],
    });
    if (this.sharedService.env.production === false && this.shareObject.data.type == 'add') {
      this.formHandle.patchValue({
        email: `abc${Date.now().toString(27)}@gmail.com`,
        password: '123123',
        name: 'abc',
        identify: `${Date.now()}`,
        address: `abc ${Date.now().toString(27)} street`,
        dob: '2005-01-01',
        workStart: new Date().toISOString().split('T')[0],
        // salaryCoefficient: 2,
        phone: `${Date.now()}`,
        employeeGroup: '68012491e9cab0670b20274e',
      })
    }
    this.filterForm = this.fb.group({
      employeeGroup: [''],
      startDate: [''],
      endDate: [''],
      // startDate: [new Date(Date.now() - 30 * 24 * 60 * 60 * 1000).toISOString().split('T')[0]],
      // endDate: [new Date().toISOString().split('T')[0]],
      limit: [this.sharedService.env.pageSize[0]],
      keyword: [''],
    })
    if (this.shareObject.data.type == 'add' || this.shareObject.data.type == 'edit') {
      this.shareObject.groupName = this.translate.instant('select_employee_group');
      this.getPermissions();
      this.getStores();
    }
    if (this.shareObject.data.type == 'edit') {
      this.getItem();
    } else {
      this.getItems();
    }
    this.getEmployeeGroup();
  }
  get roles(): FormArray {
    return this.formHandle.get('roles') as FormArray;
  }
  getPermissions() {
    if (this.sharedService.shareObject.permissions) return;
    this.sharedService.callApi(`${this.shareObject.component}/get_user_roles`, {}).subscribe({
      next: (res: any) => {
        this.sharedService.shareObject.permissions = Object.keys(res.data).map((key: any) => {
          return {
            name: key,
            nameText: this.translate.instant(`permissions.${key}`),
            permissions: res.data[key].map((e: any) => `${key}.${e}`),
          }
        });
        if (this.sharedService.env.production === false) {
          let masterRoles = this.sharedService.shareObject.permissions.map((e: any) => `permissions.${e.name}`);
          let roles = this.sharedService.shareObject.permissions.map((e: any) => e.permissions).flat();
          let arrTranslate = [masterRoles, roles].flat().map((e: any) => `this.translate.instant('${e}');`).join('\n');
          console.log(arrTranslate);
        }

      },
      error: (err: any) => {
        this.sharedService.toast({
          title: this.translate.instant('error'),
          message: err.error.message,
          type: 'danger',
        });
      }
    })
  }
  getStores() {
    this.sharedService.callApi('/store_manager/list', {}).subscribe((res: any) => {
      if (res.success) {
        this.shareObject.stores = res.data.data;
        if (this.shareObject.data.type == 'add') {
          this.formHandle.patchValue({
            store: res.data.data[0]?.id,
          });
        }
      } else {
        this.sharedService.toast({
          title: this.translate.instant('error'),
          message: res.message,
          type: 'danger',
        });
      }
    });
  }
  getItems() {
    this.shareObject.filterBox = false;
    this.shareObject.isLoading = true;
    let path = this.shareObject.data.type == 'deleted' ? `${this.shareObject.component}/list_deleted` : `${this.shareObject.component}/list`;
    this.sharedService.callApi(path, this.shareObject.options).subscribe({
      next: (res: any) => {
        this.shareObject.isLoading = false
        if (res.success) {
          this.shareObject.items = res.data.data.map((e: any) => {
            e.statusText = e.status == 0 ? this.translate.instant('status_inactive') : this.translate.instant('status_active')
            e.editURL = `/user/employee/edit/${e.id}`;
            return e;
          })
          this.shareObject.pagination = res.data.pagination;
        } else {
          this.sharedService.toast({
            title: this.translate.instant('error'),
            message: res.message,
            type: 'danger',
          });
        }
      },
      error: (err: any) => {
        this.shareObject.isLoading = false
        this.sharedService.toast({
          title: this.translate.instant('error'),
          message: err.error.message,
          type: 'danger',
        });
      }
    })
  }
  getItem() {
    this.shareObject.isLoading = true
    this.sharedService.callApi(`${this.shareObject.component}/get`, { id: this.shareObject.id }).subscribe({
      next: (res: any) => {
        this.shareObject.employee = res.data;
        let profile = res.data.profile;
        this.selectedRoles = res.data.roles;
        this.formHandle.patchValue({
          name: profile?.name,
          store: res.data.profile.store?.id,
          email: res.data?.email,
          password: res.data?.password,
          phone: profile?.phone,
          identify: profile?.identify,
          employeeGroup: profile?.employeeGroup?.id,
          address: profile?.address,
          dob: new Date(profile?.dob || Date.now()).toISOString().split('T')[0],
          workStart: new Date(profile?.workStart || Date.now()).toISOString().split('T')[0],
        });
        this.shareObject.groupName = res.data.profile?.employeeGroup?.name ?? this.translate.instant('select_employee_group');
      },
      error: (err: any) => {
        this.shareObject.isLoading = false
        this.sharedService.toast({
          title: this.translate.instant('error'),
          message: err.error.message,
          type: 'danger',
        });
      },
      complete: () => {
        this.shareObject.isLoading = false
      }
    })
  }
  addItem() {
    let payload = {
      email: this.formHandle.value.email,
      password: this.formHandle.value.password,
      roles: this.selectedRoles,
      profile: {
        store: this.formHandle.value.store,
        name: this.formHandle.value.name,
        phone: this.formHandle.value.phone,
        identify: this.formHandle.value.identify,
        address: this.formHandle.value.address,
        dob: new Date(this.formHandle.value.dob).getTime(),
        workStart: new Date(this.formHandle.value.workStart),
        // salaryCoefficient: this.formHandle.value.salaryCoefficient,
        employeeGroup: this.formHandle.value.employeeGroup
      }
    }
    this.shareObject.isLoading = true
    this.sharedService.callApi(`${this.shareObject.component}/add`, payload).subscribe({
      next: (res: any) => {
        if (res.success) {
          this.shareObject.isLoading = false
          this.sharedService.toast({
            title: this.translate.instant('success'),
            message: this.translate.instant('add_success'),
            type: 'success',
          });
          this.router.navigate(['/user/employee/manager']);
        } else {
          this.shareObject.isLoading = false
          this.sharedService.toast({
            title: this.translate.instant('error'),
            message: res.message,
            type: 'danger',
          });
        }
      },
      error: (err: any) => {
        this.shareObject.isLoading = false
        this.sharedService.toast({
          title: this.translate.instant('error'),
          message: err.error.message,
          type: 'danger',
        });
      }
    })
  }
  updateItem() {
    this.shareObject.isLoading = true;
    let payload: any = {
      id: this.shareObject.id,
      roles: Array.from(new Set(this.selectedRoles)),
      email: this.formHandle.value.email,
      password: this.formHandle.value.password,
      profile: {
        store: this.formHandle.value.store,
        name: this.formHandle.value.name,
        phone: this.formHandle.value.phone,
        identify: this.formHandle.value.identify,
        address: this.formHandle.value.address,
        dob: new Date(this.formHandle.value.dob).getTime(),
        workStart: new Date(this.formHandle.value.workStart),
        // salaryCoefficient: this.formHandle.value.salaryCoefficient,
        employeeGroup: this.formHandle.value.employeeGroup,
      }
    };
    this.sharedService.callApi(`${this.shareObject.component}/update`, payload).subscribe({
      next: (res: any) => {
        this.shareObject.isLoading = false
        this.sharedService.toast({
          title: this.translate.instant('success'),
          message: this.translate.instant('update_success'),
          type: 'success',
        });
        this.router.navigate(['/user/employee/manager']);
      },
      error: (err: any) => {
        this.shareObject.isLoading = false
        this.sharedService.toast({
          title: this.translate.instant('error'),
          message: this.translate.instant('update_failed'),
          type: 'danger',
        });
      }
    })
  }
  onSubmit() {
    this.sharedService.validateForm(this.formHandle);
    if (this.shareObject.data.type == 'edit') {
      this.updateItem()
    }
    else {
      this.addItem()
    }
  }
  deleteItem(ids: string[]) {
    this.sharedService.confirm({
      title: this.translate.instant('confirm'),
      message: this.translate.instant('confirm_delete'),
    }).then((confirmed: any) => {
      if (confirmed) {
        console.log('confirmed')
        this.shareObject.isLoading = true
        this.sharedService.callApi(`${this.shareObject.component}/delete_many`, { ids }).subscribe({
          next: (res: any) => {
            this.shareObject.isLoading = false
            this.sharedService.toast({
              title: this.translate.instant('success'),
              message: this.translate.instant('delete_success'),
              type: 'success',
            });
            this.shareObject.items = this.shareObject.items.filter((item: any) => !ids.includes(item.id));
          },
          error: (err: any) => {
            this.shareObject.isLoading = false
            this.sharedService.toast({
              title: this.translate.instant('error'),
              message: err.error.message,
              type: 'danger',
            });
          }
        })
      }
    })
  }
  getEmployeeGroup(keyword: any = null) {
    let payload: any = {};
    if (keyword) {
      payload.keyword = keyword;
    }
    this.shareObject.isLoading = true
    this.sharedService.callApi('/employee_group/list', payload).subscribe({
      next: (res: any) => {
        this.shareObject.employeeGroups = res.data.data;
        // this.formHandle.patchValue({
        //   employeeGroup: res.data.data[0].id
        // })
      },
      error: (err: any) => {
        this.shareObject.isLoading = false
        this.sharedService.toast({
          title: this.translate.instant('error'),
          message: err.error.message,
          type: 'danger',
        });
      },
      complete: () => {
        this.shareObject.isLoading = false
      }
    })
  }
  onPageChange(page: any) {
    this.shareObject.options.page = page;
    this.getItems();
  }
  getValueBulk() {
    let value = this.employeeInfo.split('\n').map((e: any) => {
      const [name, phone, identify, dob, address, employeeGroup] = e.split('|').map((a: any) => a.trim());
      return { name, phone, identify, dob, address, employeeGroup };
    });
    this.sharedService.callApi(`${this.shareObject.component}/add_many`, { data: value }).subscribe({
      next: (res: any) => {
        this.shareObject.isLoading = false
        this.sharedService.toast({
          title: this.translate.instant('success'),
          message: this.translate.instant('add_success'),
          type: 'success',
        });
      },
      error: (err: any) => {
        this.shareObject.isLoading = false
        this.sharedService.toast({
          title: this.translate.instant('error'),
          message: err.error.message,
          type: 'danger',
        });
      }
    })
  }
  softDeleteItem(ids: any) {
    ids = this.handleIndextoId(ids);
    this.sharedService.confirm({
      title: this.translate.instant('confirm'),
      message: this.translate.instant('confirm_delete'),
    }).then((confirmed: any) => {
      if (confirmed) {
        console.log('confirmed')
        this.shareObject.isLoading = true
        this.sharedService.callApi(`${this.shareObject.component}/delete_soft_many`, { ids }).subscribe({
          next: (res: any) => {
            this.shareObject.isLoading = false
            this.sharedService.toast({
              title: this.translate.instant('success'),
              message: this.translate.instant('delete_success'),
              type: 'success',
            });
            this.shareObject.items = this.shareObject.items.filter((item: any) => !ids.includes(item.id));
            this.shareObject.selectedRows.clear();
          },
          error: (err: any) => {
            this.shareObject.isLoading = false
            this.sharedService.toast({
              title: this.translate.instant('error'),
              message: err.error.message,
              type: 'danger',
            });
          }
        })
      }
    })
  }
  restoreItem(ids: any) {
    ids = this.handleIndextoId(ids);
    this.sharedService.confirm({
      title: this.translate.instant('confirm'),
      message: this.translate.instant('confirm_restore'),
    }).then((confirmed: any) => {
      if (confirmed) {
        console.log('confirmed')
        this.shareObject.isLoading = true
        this.sharedService.callApi(`${this.shareObject.component}/restore_many`, { ids }).subscribe({
          next: (res: any) => {
            this.shareObject.isLoading = false
            this.sharedService.toast({
              title: this.translate.instant('success'),
              message: this.translate.instant('restore_success'),
              type: 'success',
            });
            this.shareObject.items = this.shareObject.items.filter((item: any) => !ids.includes(item.id));
            this.shareObject.selectedRows.clear();
          },
          error: (err: any) => {
            this.shareObject.isLoading = false
            this.sharedService.toast({
              title: this.translate.instant('error'),
              message: err.error.message,
              type: 'danger',
            });
          }
        })
      }
    })
  }
  clear() {
    this.shareObject.options = { filter: {}, page: 1, limit: this.sharedService.env.pageSize[0] };
    this.filterForm.reset();
    this.filterForm.patchValue({
      limit: this.sharedService.env.pageSize[0],
      startDate: new Date(Date.now() - 30 * 24 * 60 * 60 * 1000).toISOString().split('T')[0],
      endDate: new Date().toISOString().split('T')[0],
      employeeGroup: ''
    })
    this.getItems();
  }
  filter(key: any, value: any) {
    console.log(key, value)
    if (!value) {
      this.filterForm.patchValue({ [key]: null });
      if (key.includes('.')) {
        this.filterForm.patchValue({ [key.split('.')[1]]: null });
      }
      delete this.shareObject.options.filter[key];
    } else {
      this.shareObject.options.filter[key] = value;
    }
    this.shareObject.options.page = 1;
    this.onSearch();
  }
  onSearch() {
    const now = new Date();
    const lastMonth = new Date(now.setMonth(now.getMonth() - 1));
    lastMonth.setHours(0, 0, 0, 0);
    // this.shareObject.options.filter.createdAt = { };
    if (this.filterForm.value.startDate) {
      this.shareObject.options.filter.createdAt.$gte = new Date(new Date(this.filterForm.value.startDate).setHours(0, 0, 0, 0));
    }
    if (this.filterForm.value.endDate) {
      this.shareObject.options.filter.createdAt.$lte = new Date(new Date(this.filterForm.value.endDate).setHours(23, 59, 59, 999));
    }
    this.shareObject.options.keyword = this.filterForm.value['keyword'] ? this.filterForm.value['keyword'].trim() : undefined;
    this.shareObject.options.page = 1;
    this.shareObject.options.limit = this.filterForm.value['limit'] || this.sharedService.env.pageSize[0];
    let employeeGroup = this.filterForm.value['employeeGroup'] ?? undefined;
    if (employeeGroup) {
      this.shareObject.options.filter[`profile.employeeGroup`] = employeeGroup;
      this.shareObject.groupName = this.shareObject.employeeGroups.find((e: any) => e.id == employeeGroup)?.name;
    }
    this.getItems();
  }
  isAllSelected(data: any[] = []): boolean {
    return this.shareObject.selectedRows.size === data.length;
  }
  toggleSelectAll(event: Event, data: any[]) {
    const isChecked = (event.target as HTMLInputElement).checked;

    if (isChecked) {
      data.forEach((_, index) => this.shareObject.selectedRows.add(index));
    } else {
      this.shareObject.selectedRows.clear();
    }
  }
  selectRow(event: MouseEvent, index: number) {
    //check nếu index đã có trong selectedRows thì bỏ chọn
    if (this.shareObject.selectedRows.has(index)) {
      this.toggleRowSelection(index);
      return;
    }
    if (event.ctrlKey || event.metaKey) {
      // Ctrl/Cmd click: toggle selection
      this.toggleRowSelection(index);
    } else if (event.shiftKey && this.shareObject.lastSelectedIndex !== null) {
      // Shift click: select range
      this.selectRange(this.shareObject.lastSelectedIndex, index);
    } else {
      // Regular click: single selection
      this.selectSingleRow(index);
    }
    this.shareObject.lastSelectedIndex = index;
  }
  toggleRowSelection(index: number) {
    if (this.shareObject.selectedRows.has(index)) {
      this.shareObject.selectedRows.delete(index);
    } else {
      this.shareObject.selectedRows.add(index);
    }
  }
  selectSingleRow(index: number) {
    this.shareObject.selectedRows.clear();
    this.shareObject.selectedRows.add(index);
  }
  selectRange(start: number, end: number) {
    this.shareObject.selectedRows.clear();
    const [from, to] = [Math.min(start, end), Math.max(start, end)];
    for (let i = from; i <= to; i++) {
      this.shareObject.selectedRows.add(i);
    }
  }
  handleIndextoId(idexes: any) {
    const selectedIds = Array.from(idexes).map((index: any) => this.shareObject.items[index].id);
    return selectedIds;
  }
  @HostListener('document:keydown.escape', ['$event'])
  handleEscape(event: KeyboardEvent) {
    this.shareObject.filterBox = false;
  }
  onChangeRole(element: any, key: any) {
    console.log('onChangeRole', element, key);
    if (element.target.checked) {
      this.selectedRoles.push(key);
    } else {
      this.selectedRoles = this.selectedRoles.filter((role: any) => role !== key);
    }
    this.selectedRoles = Array.from(new Set(this.selectedRoles)).filter(Boolean).filter((a: any) => a?.toString().includes('.'));
    console.log(this.selectedRoles);
  }
  searchEmployeeGroup(event: any) {
    let keyword = event.target.value;
    this.getEmployeeGroup(keyword);
  }
  addTranslate() {
    this.translate.instant('permissions.admin');
    this.translate.instant('permissions.call');
    this.translate.instant('permissions.callrecord');
    this.translate.instant('permissions.employee_absence');
    this.translate.instant('permissions.employee_attendance');
    this.translate.instant('permissions.employee_face');
    this.translate.instant('permissions.employee_group');
    this.translate.instant('permissions.employee_leave');
    this.translate.instant('permissions.employee_overtime');
    this.translate.instant('permissions.employee_relocation');
    this.translate.instant('permissions.employee_timesheet');
    this.translate.instant('permissions.export');
    this.translate.instant('permissions.formula_salary');
    this.translate.instant('permissions.formula_timekeeping');
    this.translate.instant('permissions.import');
    this.translate.instant('permissions.material');
    this.translate.instant('permissions.phone');
    this.translate.instant('permissions.phone_contact');
    this.translate.instant('permissions.product');
    this.translate.instant('permissions.product_group');
    this.translate.instant('permissions.store_manager');
    this.translate.instant('permissions.store_order');
    this.translate.instant('permissions.supplier');
    this.translate.instant('permissions.unit');
    this.translate.instant('permissions.users');
    this.translate.instant('permissions.warehouse');
    this.translate.instant('permissions.warehouse_order');
    this.translate.instant('permissions.work_calendar');
    this.translate.instant('admin.index');
    this.translate.instant('admin.super');
    this.translate.instant('call.index');
    this.translate.instant('call.add');
    this.translate.instant('call.add_many');
    this.translate.instant('call.update');
    this.translate.instant('call.update_many');
    this.translate.instant('call.get');
    this.translate.instant('call.delete');
    this.translate.instant('call.list');
    this.translate.instant('call.list_deleted');
    this.translate.instant('call.delete_many');
    this.translate.instant('call.restore');
    this.translate.instant('call.restore_many');
    this.translate.instant('call.history');
    this.translate.instant('call.delete_soft');
    this.translate.instant('call.delete_soft_many');
    this.translate.instant('callrecord.index');
    this.translate.instant('callrecord.add');
    this.translate.instant('callrecord.add_many');
    this.translate.instant('callrecord.update');
    this.translate.instant('callrecord.update_many');
    this.translate.instant('callrecord.get');
    this.translate.instant('callrecord.delete');
    this.translate.instant('callrecord.list');
    this.translate.instant('callrecord.list_deleted');
    this.translate.instant('callrecord.delete_many');
    this.translate.instant('callrecord.restore');
    this.translate.instant('callrecord.restore_many');
    this.translate.instant('callrecord.history');
    this.translate.instant('callrecord.delete_soft');
    this.translate.instant('callrecord.delete_soft_many');
    this.translate.instant('callrecord.report');
    this.translate.instant('callrecord.get_record');
    this.translate.instant('callrecord.update_contact');
    this.translate.instant('employee_absence.index');
    this.translate.instant('employee_absence.add');
    this.translate.instant('employee_absence.add_many');
    this.translate.instant('employee_absence.update');
    this.translate.instant('employee_absence.update_many');
    this.translate.instant('employee_absence.list');
    this.translate.instant('employee_absence.list_deleted');
    this.translate.instant('employee_absence.get');
    this.translate.instant('employee_absence.delete');
    this.translate.instant('employee_absence.delete_soft');
    this.translate.instant('employee_absence.delete_many');
    this.translate.instant('employee_absence.delete_soft_many');
    this.translate.instant('employee_absence.restore');
    this.translate.instant('employee_absence.restore_many');
    this.translate.instant('employee_absence.get_by_user');
    this.translate.instant('employee_absence.change_status');
    this.translate.instant('employee_absence.request');
    this.translate.instant('employee_attendance.index');
    this.translate.instant('employee_attendance.add');
    this.translate.instant('employee_attendance.add_many');
    this.translate.instant('employee_attendance.update');
    this.translate.instant('employee_attendance.update_many');
    this.translate.instant('employee_attendance.list');
    this.translate.instant('employee_attendance.list_deleted');
    this.translate.instant('employee_attendance.get');
    this.translate.instant('employee_attendance.delete');
    this.translate.instant('employee_attendance.delete_soft');
    this.translate.instant('employee_attendance.delete_many');
    this.translate.instant('employee_attendance.delete_soft_many');
    this.translate.instant('employee_attendance.restore');
    this.translate.instant('employee_attendance.restore_many');
    this.translate.instant('employee_attendance.attendance_by_qrcode');
    this.translate.instant('employee_attendance.attendance_by_face_id');
    this.translate.instant('employee_attendance.generate_qrcode_text');
    this.translate.instant('employee_attendance.list_attendance');
    this.translate.instant('employee_attendance.attendance_from_station');
    this.translate.instant('employee_face.index');
    this.translate.instant('employee_face.add');
    this.translate.instant('employee_face.add_many');
    this.translate.instant('employee_face.update');
    this.translate.instant('employee_face.update_many');
    this.translate.instant('employee_face.list');
    this.translate.instant('employee_face.list_deleted');
    this.translate.instant('employee_face.get');
    this.translate.instant('employee_face.delete');
    this.translate.instant('employee_face.delete_soft');
    this.translate.instant('employee_face.delete_many');
    this.translate.instant('employee_face.delete_soft_many');
    this.translate.instant('employee_face.restore');
    this.translate.instant('employee_face.restore_many');
    this.translate.instant('employee_face.get_by_user');
    this.translate.instant('employee_face.get_me');
    this.translate.instant('employee_group.index');
    this.translate.instant('employee_group.add');
    this.translate.instant('employee_group.add_many');
    this.translate.instant('employee_group.update');
    this.translate.instant('employee_group.update_many');
    this.translate.instant('employee_group.list');
    this.translate.instant('employee_group.list_deleted');
    this.translate.instant('employee_group.get');
    this.translate.instant('employee_group.delete');
    this.translate.instant('employee_group.delete_soft');
    this.translate.instant('employee_group.delete_many');
    this.translate.instant('employee_group.delete_soft_many');
    this.translate.instant('employee_group.restore');
    this.translate.instant('employee_group.restore_many');
    this.translate.instant('employee_leave.index');
    this.translate.instant('employee_leave.add');
    this.translate.instant('employee_leave.add_many');
    this.translate.instant('employee_leave.update');
    this.translate.instant('employee_leave.update_many');
    this.translate.instant('employee_leave.list');
    this.translate.instant('employee_leave.list_deleted');
    this.translate.instant('employee_leave.get');
    this.translate.instant('employee_leave.delete');
    this.translate.instant('employee_leave.delete_soft');
    this.translate.instant('employee_leave.delete_many');
    this.translate.instant('employee_leave.delete_soft_many');
    this.translate.instant('employee_leave.restore');
    this.translate.instant('employee_leave.restore_many');
    this.translate.instant('employee_leave.get_by_user');
    this.translate.instant('employee_leave.change_status');
    this.translate.instant('employee_leave.request');
    this.translate.instant('employee_overtime.index');
    this.translate.instant('employee_overtime.add');
    this.translate.instant('employee_overtime.add_many');
    this.translate.instant('employee_overtime.update');
    this.translate.instant('employee_overtime.update_many');
    this.translate.instant('employee_overtime.list');
    this.translate.instant('employee_overtime.list_deleted');
    this.translate.instant('employee_overtime.get');
    this.translate.instant('employee_overtime.delete');
    this.translate.instant('employee_overtime.delete_soft');
    this.translate.instant('employee_overtime.delete_many');
    this.translate.instant('employee_overtime.delete_soft_many');
    this.translate.instant('employee_overtime.restore');
    this.translate.instant('employee_overtime.restore_many');
    this.translate.instant('employee_overtime.request');
    this.translate.instant('employee_overtime.change_status');
    this.translate.instant('employee_overtime.get_request');
    this.translate.instant('employee_relocation.index');
    this.translate.instant('employee_relocation.add');
    this.translate.instant('employee_relocation.add_many');
    this.translate.instant('employee_relocation.update');
    this.translate.instant('employee_relocation.update_many');
    this.translate.instant('employee_relocation.list');
    this.translate.instant('employee_relocation.list_deleted');
    this.translate.instant('employee_relocation.get');
    this.translate.instant('employee_relocation.delete');
    this.translate.instant('employee_relocation.delete_soft');
    this.translate.instant('employee_relocation.delete_many');
    this.translate.instant('employee_relocation.delete_soft_many');
    this.translate.instant('employee_relocation.restore');
    this.translate.instant('employee_relocation.restore_many');
    this.translate.instant('employee_relocation.request');
    this.translate.instant('employee_relocation.change_status');
    this.translate.instant('employee_timesheet.index');
    this.translate.instant('employee_timesheet.add');
    this.translate.instant('employee_timesheet.add_many');
    this.translate.instant('employee_timesheet.update');
    this.translate.instant('employee_timesheet.update_many');
    this.translate.instant('employee_timesheet.list');
    this.translate.instant('employee_timesheet.list_deleted');
    this.translate.instant('employee_timesheet.get');
    this.translate.instant('employee_timesheet.delete');
    this.translate.instant('employee_timesheet.delete_soft');
    this.translate.instant('employee_timesheet.delete_many');
    this.translate.instant('employee_timesheet.delete_soft_many');
    this.translate.instant('employee_timesheet.restore');
    this.translate.instant('employee_timesheet.restore_many');
    this.translate.instant('export.index');
    this.translate.instant('export.add');
    this.translate.instant('export.add_many');
    this.translate.instant('export.update');
    this.translate.instant('export.update_many');
    this.translate.instant('export.get');
    this.translate.instant('export.delete');
    this.translate.instant('export.list');
    this.translate.instant('export.list_deleted');
    this.translate.instant('export.delete_many');
    this.translate.instant('export.restore');
    this.translate.instant('export.restore_many');
    this.translate.instant('export.history');
    this.translate.instant('export.delete_soft');
    this.translate.instant('export.delete_soft_many');
    this.translate.instant('formula_salary.index');
    this.translate.instant('formula_salary.add');
    this.translate.instant('formula_salary.add_many');
    this.translate.instant('formula_salary.update');
    this.translate.instant('formula_salary.update_many');
    this.translate.instant('formula_salary.list');
    this.translate.instant('formula_salary.list_deleted');
    this.translate.instant('formula_salary.get');
    this.translate.instant('formula_salary.delete');
    this.translate.instant('formula_salary.delete_soft');
    this.translate.instant('formula_salary.delete_many');
    this.translate.instant('formula_salary.delete_soft_many');
    this.translate.instant('formula_salary.restore');
    this.translate.instant('formula_salary.restore_many');
    this.translate.instant('formula_salary.get_by_user');
    this.translate.instant('formula_timekeeping.index');
    this.translate.instant('formula_timekeeping.add');
    this.translate.instant('formula_timekeeping.add_many');
    this.translate.instant('formula_timekeeping.update');
    this.translate.instant('formula_timekeeping.update_many');
    this.translate.instant('formula_timekeeping.list');
    this.translate.instant('formula_timekeeping.list_deleted');
    this.translate.instant('formula_timekeeping.get');
    this.translate.instant('formula_timekeeping.delete');
    this.translate.instant('formula_timekeeping.delete_soft');
    this.translate.instant('formula_timekeeping.delete_many');
    this.translate.instant('formula_timekeeping.delete_soft_many');
    this.translate.instant('formula_timekeeping.restore');
    this.translate.instant('formula_timekeeping.restore_many');
    this.translate.instant('formula_timekeeping.get_by_user');
    this.translate.instant('import.index');
    this.translate.instant('import.add');
    this.translate.instant('import.add_many');
    this.translate.instant('import.update');
    this.translate.instant('import.update_many');
    this.translate.instant('import.get');
    this.translate.instant('import.delete');
    this.translate.instant('import.list');
    this.translate.instant('import.list_deleted');
    this.translate.instant('import.delete_many');
    this.translate.instant('import.restore');
    this.translate.instant('import.restore_many');
    this.translate.instant('import.history');
    this.translate.instant('import.delete_soft');
    this.translate.instant('import.delete_soft_many');
    this.translate.instant('material.index');
    this.translate.instant('material.add');
    this.translate.instant('material.add_many');
    this.translate.instant('material.update');
    this.translate.instant('material.update_many');
    this.translate.instant('material.get');
    this.translate.instant('material.delete');
    this.translate.instant('material.list');
    this.translate.instant('material.list_deleted');
    this.translate.instant('material.delete_many');
    this.translate.instant('material.restore');
    this.translate.instant('material.restore_many');
    this.translate.instant('material.history');
    this.translate.instant('material.delete_soft');
    this.translate.instant('material.delete_soft_many');
    this.translate.instant('phone.index');
    this.translate.instant('phone.add');
    this.translate.instant('phone.add_many');
    this.translate.instant('phone.update');
    this.translate.instant('phone.update_many');
    this.translate.instant('phone.list');
    this.translate.instant('phone.list_deleted');
    this.translate.instant('phone.get');
    this.translate.instant('phone.delete');
    this.translate.instant('phone.delete_soft');
    this.translate.instant('phone.delete_many');
    this.translate.instant('phone.delete_soft_many');
    this.translate.instant('phone.restore');
    this.translate.instant('phone.restore_many');
    this.translate.instant('phone.history');
    this.translate.instant('phone_contact.index');
    this.translate.instant('phone_contact.add');
    this.translate.instant('phone_contact.add_many');
    this.translate.instant('phone_contact.update');
    this.translate.instant('phone_contact.update_many');
    this.translate.instant('phone_contact.list');
    this.translate.instant('phone_contact.list_deleted');
    this.translate.instant('phone_contact.get');
    this.translate.instant('phone_contact.delete');
    this.translate.instant('phone_contact.delete_soft');
    this.translate.instant('phone_contact.delete_many');
    this.translate.instant('phone_contact.delete_soft_many');
    this.translate.instant('phone_contact.restore');
    this.translate.instant('phone_contact.restore_many');
    this.translate.instant('phone_contact.history');
    this.translate.instant('phone_contact.get_birthdays');
    this.translate.instant('product.index');
    this.translate.instant('product.add');
    this.translate.instant('product.add_many');
    this.translate.instant('product.update');
    this.translate.instant('product.update_many');
    this.translate.instant('product.get');
    this.translate.instant('product.delete');
    this.translate.instant('product.list');
    this.translate.instant('product.list_deleted');
    this.translate.instant('product.delete_many');
    this.translate.instant('product.restore');
    this.translate.instant('product.restore_many');
    this.translate.instant('product.history');
    this.translate.instant('product.delete_soft');
    this.translate.instant('product.delete_soft_many');
    this.translate.instant('product_group.index');
    this.translate.instant('product_group.add');
    this.translate.instant('product_group.add_many');
    this.translate.instant('product_group.update');
    this.translate.instant('product_group.update_many');
    this.translate.instant('product_group.list');
    this.translate.instant('product_group.list_deleted');
    this.translate.instant('product_group.get');
    this.translate.instant('product_group.delete');
    this.translate.instant('product_group.delete_soft');
    this.translate.instant('product_group.delete_many');
    this.translate.instant('product_group.delete_soft_many');
    this.translate.instant('product_group.restore');
    this.translate.instant('product_group.restore_many');
    this.translate.instant('product_group.history');
    this.translate.instant('store_manager.index');
    this.translate.instant('store_manager.add');
    this.translate.instant('store_manager.add_many');
    this.translate.instant('store_manager.update');
    this.translate.instant('store_manager.update_many');
    this.translate.instant('store_manager.list');
    this.translate.instant('store_manager.list_deleted');
    this.translate.instant('store_manager.get');
    this.translate.instant('store_manager.delete');
    this.translate.instant('store_manager.delete_soft');
    this.translate.instant('store_manager.delete_many');
    this.translate.instant('store_manager.delete_soft_many');
    this.translate.instant('store_manager.restore');
    this.translate.instant('store_manager.restore_many');
    this.translate.instant('store_manager.history');
    this.translate.instant('store_order.index');
    this.translate.instant('store_order.add');
    this.translate.instant('store_order.add_many');
    this.translate.instant('store_order.update');
    this.translate.instant('store_order.update_many');
    this.translate.instant('store_order.get');
    this.translate.instant('store_order.delete');
    this.translate.instant('store_order.list');
    this.translate.instant('store_order.list_deleted');
    this.translate.instant('store_order.delete_many');
    this.translate.instant('store_order.restore');
    this.translate.instant('store_order.restore_many');
    this.translate.instant('store_order.history');
    this.translate.instant('store_order.delete_soft');
    this.translate.instant('store_order.delete_soft_many');
    this.translate.instant('supplier.index');
    this.translate.instant('supplier.add');
    this.translate.instant('supplier.add_many');
    this.translate.instant('supplier.update');
    this.translate.instant('supplier.update_many');
    this.translate.instant('supplier.get');
    this.translate.instant('supplier.delete');
    this.translate.instant('supplier.list');
    this.translate.instant('supplier.list_deleted');
    this.translate.instant('supplier.delete_many');
    this.translate.instant('supplier.restore');
    this.translate.instant('supplier.restore_many');
    this.translate.instant('supplier.history');
    this.translate.instant('supplier.delete_soft');
    this.translate.instant('supplier.delete_soft_many');
    this.translate.instant('unit.index');
    this.translate.instant('unit.add');
    this.translate.instant('unit.add_many');
    this.translate.instant('unit.update');
    this.translate.instant('unit.update_many');
    this.translate.instant('unit.get');
    this.translate.instant('unit.delete');
    this.translate.instant('unit.list');
    this.translate.instant('unit.list_deleted');
    this.translate.instant('unit.delete_many');
    this.translate.instant('unit.restore');
    this.translate.instant('unit.restore_many');
    this.translate.instant('unit.history');
    this.translate.instant('unit.delete_soft');
    this.translate.instant('unit.delete_soft_many');
    this.translate.instant('users.index');
    this.translate.instant('users.add');
    this.translate.instant('users.add_many');
    this.translate.instant('users.update');
    this.translate.instant('users.update_many');
    this.translate.instant('users.list');
    this.translate.instant('users.list_deleted');
    this.translate.instant('users.get');
    this.translate.instant('users.delete');
    this.translate.instant('users.delete_soft');
    this.translate.instant('users.delete_many');
    this.translate.instant('users.delete_soft_many');
    this.translate.instant('users.restore');
    this.translate.instant('users.restore_many');
    this.translate.instant('users.profile');
    this.translate.instant('users.profile_update');
    this.translate.instant('users.get_user_perms');
    this.translate.instant('users.get_user_roles');
    this.translate.instant('users.list_attendance');
    this.translate.instant('users.list_relocation');
    this.translate.instant('users.list_absence');
    this.translate.instant('users.list_leave');
    this.translate.instant('users.get_user_workcalendar');
    this.translate.instant('users.get_work_calendar');
    this.translate.instant('users.face_id_station');
    this.translate.instant('users.add_face_id');
    this.translate.instant('warehouse.index');
    this.translate.instant('warehouse.add');
    this.translate.instant('warehouse.add_many');
    this.translate.instant('warehouse.update');
    this.translate.instant('warehouse.update_many');
    this.translate.instant('warehouse.get');
    this.translate.instant('warehouse.delete');
    this.translate.instant('warehouse.list');
    this.translate.instant('warehouse.list_deleted');
    this.translate.instant('warehouse.delete_many');
    this.translate.instant('warehouse.restore');
    this.translate.instant('warehouse.restore_many');
    this.translate.instant('warehouse.history');
    this.translate.instant('warehouse.delete_soft');
    this.translate.instant('warehouse.delete_soft_many');
    this.translate.instant('warehouse_order.index');
    this.translate.instant('warehouse_order.add');
    this.translate.instant('warehouse_order.add_many');
    this.translate.instant('warehouse_order.update');
    this.translate.instant('warehouse_order.update_many');
    this.translate.instant('warehouse_order.get');
    this.translate.instant('warehouse_order.delete');
    this.translate.instant('warehouse_order.list');
    this.translate.instant('warehouse_order.list_deleted');
    this.translate.instant('warehouse_order.delete_many');
    this.translate.instant('warehouse_order.restore');
    this.translate.instant('warehouse_order.restore_many');
    this.translate.instant('warehouse_order.history');
    this.translate.instant('warehouse_order.delete_soft');
    this.translate.instant('warehouse_order.delete_soft_many');
    this.translate.instant('work_calendar.index');
    this.translate.instant('work_calendar.add');
    this.translate.instant('work_calendar.add_many');
    this.translate.instant('work_calendar.update');
    this.translate.instant('work_calendar.update_many');
    this.translate.instant('work_calendar.list');
    this.translate.instant('work_calendar.list_deleted');
    this.translate.instant('work_calendar.get');
    this.translate.instant('work_calendar.delete');
    this.translate.instant('work_calendar.delete_soft');
    this.translate.instant('work_calendar.delete_many');
    this.translate.instant('work_calendar.delete_soft_many');
    this.translate.instant('work_calendar.restore');
    this.translate.instant('work_calendar.restore_many');
    this.translate.instant('work_calendar.get_by_user');
  }
}

